import * as React from 'react';

export const ValidationFailed = () => {
  return (
    <div className="error-block-container">
      <h1>Whoops!</h1>
      <p>Missing something? Please check the areas marked in red before you continue.</p>
    </div>
  )
}
